import React, { Component } from 'react';

import {Link} from 'react-router-dom';

import PropTypes from 'prop-types';

const style = {
    marginLeft: '20px',
    display: 'inline'
}

class Header extends Component {

    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    logOutButtonClicked = () => {
         //por o isLogged a false
         localStorage.removeItem('isLoggedIn');
         //apagar o que está no token
         localStorage.removeItem('token');

         this.context.router.history.push(
            "/login"
          );
    }

    render() {
        return (
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container">
                    <Link className="navbar-brand" to="/backoffice/pontos_interesse">
                        <img src="/images/logo-marca.png" width="70" height="70" alt=""/>
                        <p style={style}>Backoffice Site Junta Sabugueiro</p>
                    </Link>
                    <div className="backoffice-navbar-button">
                        <button onClick={this.logOutButtonClicked} className="btn btn-outline-secondary">Logout</button>
                    </div>
                </div>
            </nav>
        )
    }
}

export default Header;
